import React, { useEffect, useRef } from 'react';
import '../../styles/DashboardEditor.css';

/**
 * Side panel used by the dashboard editor. It slides in from the right and
 * leaves the dashboard visible and interactive, so you can see what you are
 * changing. Escape closes it; focus moves into it when it opens.
 */
const EditorDrawer = ({ title, subtitle, onClose, children, footer, width = 420, labelId = 'editor-drawer-title' }) => {
  const ref = useRef(null);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    ref.current?.focus();
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <aside className="editor-drawer" style={{ width }} role="dialog" aria-modal="false" aria-labelledby={labelId} ref={ref} tabIndex={-1}>
      <header className="editor-drawer-header">
        <div>
          <h2 id={labelId}>{title}</h2>
          {subtitle && <p className="editor-drawer-subtitle">{subtitle}</p>}
        </div>
        <button type="button" className="editor-drawer-close" onClick={onClose} aria-label="Close panel">×</button>
      </header>
      <div className="editor-drawer-body">{children}</div>
      {footer && <footer className="editor-drawer-footer">{footer}</footer>}
    </aside>
  );
};

export default EditorDrawer;
